import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

// Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

// Import Components
import MiniWidgets from "./MiniWidgets";
import AttendanceAnalytics from "./AttendanceAnalytics";
import EarningReports from "./EarningReports";
import studentIcon from "../../assets/images/icons/student.gif";
import teacherIcon from "../../assets/images/icons/teacher2.gif";
import moneyIcon from "../../assets/images/icons/analytics.gif";
import AdnimTodoList from "./TodoList";
import AdminAttendance from "./Attendance";

const Dashboard = () => {
    const [breadcrumbItems] = useState([
        { title: "Brandstrek", link: "/" },
        { title: "Dashboard", link: "#" },
    ]);


    const [reports] = useState([
        { icon: studentIcon, title: "Number of Projects", value: "150", rate: "2.4%", desc: "loreum website" },
        { icon: moneyIcon, title: "Collected today", value: "₹ 38452", rate: "2.4%", desc: "From yesterday" },
        { icon: teacherIcon, title: "Staffs", value: "23", rate: "2.4%", desc: "loreum website" },
    ]);

    return (

        <div className="page-content ">
            <Container fluid>
                <Breadcrumbs title="Dashboard" breadcrumbItems={breadcrumbItems} />

                <Row>
                    <Col xl={8}>
                        <Row>
                            <MiniWidgets reports={reports} />
                        </Row>

                        <AdnimTodoList />
                    </Col>

                    <Col xl={4}>

                        <AdminAttendance />
                        < AttendanceAnalytics />

                        {/* Earning Reports */}
                        <EarningReports />
                    </Col>

                </Row>
                <Row className="mt-3">
                    <Col xl={6}>
                        <Card
                            className="shadow-sm border-0 overflow-hidden"
                            style={{
                                background: "linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%)",
                                borderRadius: "12px",
                            }}
                        >
                            <CardBody className="d-flex align-items-center justify-content-between py-4 px-4">
                                <div className="d-flex align-items-center gap-3">
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-25"
                                        style={{ width: "56px", height: "56px", flexShrink: 0 }}
                                    >
                                        <i className="ri-search-eye-line text-white fs-2"></i>
                                    </div>
                                    <div>
                                        <h5 className="text-white mb-1 fw-bold">Web Audit</h5>
                                        <p className="text-white-50 mb-0 small">
                                            View and manage all web audit records
                                        </p>
                                    </div>
                                </div>
                                <Link
                                    to="/admin/webaudit"
                                    className="btn btn-light fw-semibold px-4 d-flex align-items-center gap-2"
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    View Audits <i className="ri-arrow-right-line"></i>
                                </Link>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xl={6}>
                        <Card
                            className="shadow-sm border-0 overflow-hidden"
                            style={{
                                background: "linear-gradient(135deg, #6f42c1 0%, #e83e8c 100%)",
                                borderRadius: "12px",
                            }}
                        >
                            <CardBody className="d-flex align-items-center justify-content-between py-4 px-4">
                                <div className="d-flex align-items-center gap-3">
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-25"
                                        style={{ width: "56px", height: "56px", flexShrink: 0 }}
                                    >
                                        <i className="ri-gift-line text-white fs-2"></i>
                                    </div>
                                    <div>
                                        <h5 className="text-white mb-1 fw-bold">Lucky Draw</h5>
                                        <p className="text-white-50 mb-0 small">
                                            View and manage all lucky draw entries
                                        </p>
                                    </div>
                                </div>
                                <Link
                                    to="/admin/luckydraw"
                                    className="btn btn-light fw-semibold px-4 d-flex align-items-center gap-2"
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    View Draws <i className="ri-arrow-right-line"></i>
                                </Link>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Dashboard;
